import Button, { BUTTON_HEIGHT_32 } from '../../Button'

import DeleteIcon from '../../../icons/delete.svg'

export const ENTITY_PROFILE_HEADER_INFO_ITEM_DEADLINE_QA_NAME =
  'entityProfileHeaderDeadline'

export const ENTITY_PROFILE_HEADER_INFO_ITEM_DEADLINE_DATE_QA_NAME =
  'entityProfileHeaderDeadlineDate'

export const ENTITY_PROFILE_HEADER_INFO_ITEM_DEADLINE_TIME_QA_NAME =
  'entityProfileHeaderDeadlineTime'

export const ENTITY_PROFILE_HEADER_INFO_ITEM_DEADLINE_DELETE_QA_NAME =
  'entityProfileHeaderDeadlineDeleteBtn'

export const ENTITY_PROFILE_HEADER_INFO_ITEM_DEADLINE_ACTIONS_KEY_DELETE =
  'delete'

export const ENTITY_PROFILE_HEADER_INFO_ITEM_DEADLINE_ACTIONS = [
  {
    Button: Button.Outlined,
    key: ENTITY_PROFILE_HEADER_INFO_ITEM_DEADLINE_ACTIONS_KEY_DELETE,
    props: {
      beforeIconProps: { Icon: DeleteIcon },
      height: BUTTON_HEIGHT_32,
      qaName: ENTITY_PROFILE_HEADER_INFO_ITEM_DEADLINE_DELETE_QA_NAME,
      tooltip: 'RequestProfile.HeaderDeadlineDeleteBtnTooltipKey',
    },
    show: contentExist => contentExist,
  },
]
